import { useLang, scrollToId } from "@/i18n";
import { useLocation, useNavigate } from "react-router-dom";

export function LogoMark({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className="animate-spin-slower"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="vortexGrad" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0%" stopColor="#00f0ff" />
          <stop offset="55%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#8b5cf6" />
        </linearGradient>
      </defs>
      <path
        d="M24 6a18 18 0 0 1 15.6 9"
        stroke="url(#vortexGrad)"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path d="M40.5 9.5l1.6 6.4-6.6-.8z" fill="#00f0ff" />
      <path
        d="M24 42a18 18 0 0 1-15.6-9"
        stroke="url(#vortexGrad)"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path d="M7.5 38.5l-1.6-6.4 6.6.8z" fill="#8b5cf6" />
      <circle cx="24" cy="24" r="4" fill="url(#vortexGrad)" />
    </svg>
  );
}

export default function Nav() {
  const { lang, toggle, t } = useLang();
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const goHome = () => {
    if (isHome) scrollToId("top");
    else navigate("/");
  };

  const goContact = () => {
    if (isHome) scrollToId("contact");
    else {
      navigate("/");
      setTimeout(() => scrollToId("contact"), 200);
    }
  };

  return (
    <header
      data-testid="main-navigation-bar"
      className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#030712]/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-10">
        <button
          data-testid="brand-logo-button"
          onClick={goHome}
          className="flex items-center gap-3 min-h-12"
        >
          <LogoMark />
          <span className="font-display text-base sm:text-lg font-bold tracking-tight">
            Studio <span className="text-vortex-gradient">vortex 360</span>
          </span>
        </button>
        <div className="flex items-center gap-2 sm:gap-4">
          <button
            data-testid="desktop-contact-cta-button"
            onClick={goContact}
            className="hidden md:inline-flex items-center min-h-12 px-6 rounded-full text-sm font-semibold text-slate-200 border border-white/15 hover:border-cyan-400/60 hover:text-cyan-300 transition-colors duration-300"
          >
            {t.nav.contact}
          </button>
          <button
            data-testid="language-switch-toggle"
            onClick={toggle}
            aria-label="Switch language"
            className="inline-flex items-center justify-center min-h-12 min-w-12 px-4 rounded-full border border-cyan-400/40 bg-cyan-400/5 font-mono-accent text-sm font-semibold text-cyan-300 hover:bg-cyan-400/15 hover:shadow-[0_0_18px_rgba(0,240,255,0.25)] transition-all duration-300"
          >
            {lang === "hu" ? "EN" : "HU"}
          </button>
        </div>
      </div>
    </header>
  );
}
